import { render, staticRenderFns } from "./livestop.vue?vue&type=template&id=ba9641fa&scoped=true"
import script from "./livestop.vue?vue&type=script&lang=js"
export * from "./livestop.vue?vue&type=script&lang=js"
import style0 from "./livestop.vue?vue&type=style&index=0&id=ba9641fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9641fa",
  null
  
)

export default component.exports